import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BannerApi } from 'api';
import type { Banner } from 'api/methods/BannerApi';

/**
 * [Banner] Query key 생성
 * --
 */
export const bannerQueryKeys = createQueryKeys('banner', {
  getBanner: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getBanners: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Banner] 배너 전체 조회
 * --
 */
export const useGetBanners = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: bannerQueryKeys.getBanners(params).queryKey,
    queryFn: () => BannerApi.getBanners(params),
    ...options,
  });
  return data;
};

/**
 * [Banner] 배너 상세 조회
 * --
 */
export const useGetBanner = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: bannerQueryKeys.getBanner(idx, params).queryKey,
    queryFn: () => BannerApi.getBanner(idx, params),
  });

  return data;
};

/**
 * [Banner] 배너 생성
 * --
 */
export const useCreateBanner = (body: Banner) => {
  const { mutateAsync: createBanner, ...result } = useMutation({
    mutationFn: (variables: Banner) => BannerApi.createBanner(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createBanner, ...result };
};

/**
 * [Banner] 배너 수정
 * --
 */
export const useUpdateBanner = (body: Banner) => {
  const { mutateAsync: updateBanner, ...result } = useMutation({
    mutationFn: (variables: Banner) => BannerApi.updateBanner(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateBanner, ...result };
};

/**
 * [Banner] 배너 삭제
 * --
 */
export const useDeleteBanner = (idx: number) => {
  const { mutateAsync: deleteBanner, ...result } = useMutation({
    mutationFn: (variables: number) => BannerApi.deleteBanner(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteBanner, ...result };
};

/**
 * [Banner] 배너 생성
 * --
 */
export const useUpsertBanner = () => {
  const { mutateAsync: upsertBanner, ...result } = useMutation({
    mutationFn: (variables: Banner[]) => BannerApi.upsertBanner(variables),
  });

  return { upsertBanner, ...result };
};
